import { render, staticRenderFns } from "./Vendedor.vue?vue&type=template&id=3642a03a&scoped=true&"
import script from "./Vendedor.vue?vue&type=script&lang=js&"
export * from "./Vendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642a03a",
  null
  
)

export default component.exports